import React, { FC, ReactNode } from "react";
import Typography from "@mui/material/Typography";

/**
 * The small uppercase amber label the site places above section headings.
 *
 * Decorative only: 12px/700 amber on white is roughly 1.9:1, which fails AA as
 * body text. Always pair it with a real heading, never use it as the sole label.
 */
const Eyebrow: FC<{ children: ReactNode; sx?: object }> = ({ children, sx }) => (
  <Typography variant="eyebrow" sx={{ mb: 1.5, ...sx }}>
    {children}
  </Typography>
);

export default Eyebrow;
